import { Component } from '@angular/core'

@Component({
  selector: 'mg-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  standalone: false
})
export class TestComponent {}
